import { makeStyles } from '@rbx/ui';

const useTryInStudioDialogStyles = makeStyles()(() => ({
  iframe: {
    display: 'none',
    overflow: 'hidden',
  },
  container: {
    width: 500,
    height: 320,
    overflow: 'hidden',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  loadingContainer: {
    width: '100%',
  },
}));

export default useTryInStudioDialogStyles;
